import { Container, Row, Col } from 'react-bootstrap';

const pongal2020 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/sankranthi-and-pongal-2020.webp"
const xmas2019 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/christmas-celebration-2019.webp"
const xmas2018 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/christmas-celebration-2018.webp"
const medicalCamp2018 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/medical-camp-2018.webp"
const Kerala2018 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/kerala-flood-contribution-2018.webp"
const newOffice = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/group-img.webp"
const teamdinner2018 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/team-dinner-2018.webp"
const xmasdinner2018 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/sankranthi-and-pongal-2020.webp"
const pongal2018 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/sankranthi-and-pongal-2018.webp"
const pongal2017 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/sankranthi-and-pongal-2017.webp"
const cricket = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/cricket-tournament-2016.webp"
const teamLunch2016 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/team-lunch-2016.webp"
const teamOuting = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/team-outing-at-mango-mist-2017.webp"
const xmas2017 = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/christmas-celebration-2017.webp"

const LifeAtAcube = () => {
    const events = [
        {
            imgSrc: pongal2020,
            title: "SANKRANTHI AND PONGAL - 2020",
            description: "Parade in Ethnic wear!!",
        },
        {
            imgSrc: xmas2019,
            title: "CHRISTMAS CELEBRATION - 2019",
            description: "Santa and his gifts!!",
        },
        {
            imgSrc: xmas2018,
            title: "CHRISTMAS CELEBRATION - 2018",
            description: "Santa and his gifts!!",
        },
        {
            imgSrc: medicalCamp2018,
            title: "MEDICAL CAMP - 2018",
            description: "Medical camp at office for employees and their families.!",
        },
        {
            imgSrc: Kerala2018,
            title: "KERALA FLOOD CONTRIBUTION - 2018",
            description: "Acube's contribution for flood affected kerala!!",
        },
        {
            imgSrc: newOffice,
            title: "NEW OFFICE INAUGURATION - 2018",
            description: "Acube's new home!!",
        },
        {
            imgSrc: teamdinner2018,
            title: "TEAM DINNER - 2018",
            description: "Team dinner with Acube family once in 6 months!!",
        },
        {
            imgSrc: xmasdinner2018,
            title: "CHRISTMAS DINNER - 2018",
            description: "Acube's Christmas dinner!!",
        },
        {
            imgSrc: pongal2018,
            title: "SANKRANTHI AND PONGAL - 2018",
            description: "Parade in Ethnic wear!!",
        },
        {
            imgSrc: xmas2017,
            title: "CHRISTMAS CELEBRATION - 2017",
            description: "Santa and his gifts!!",
        },
        {
            imgSrc: teamOuting,
            title: "TEAM OUTING AT MANGO MIST - 2017",
            description: "Full Fun & Masti and Mango Mist!!",
        },
        {
            imgSrc: pongal2017,
            title: "SANKRANTHI AND PONGAL - 2017",
            description: "Acube's Sankranthi and Pongal!!",
        },
        {
            imgSrc: cricket,
            title: "CRICKET TOURNAMENT - 2016",
            description: "Acube's cricket team!!",
        },
        {
            imgSrc: teamLunch2016,
            title: "TEAM LUNCH - 2016",
            description: "Acube's team dinner!!",
        },
    ];

    return (
        <section className="py-5 events-section">
            <Container>
                <h2 className="text-primary text-center mb-2 ft-wt-700">Life @ Acube</h2>
                <p className="text-center mb-4">WORK AND PLAY GOES HAND IN HAND AT ACUBE.</p>
                <Row className="justify-content-center">
                    <Col xl={12}>
                        <Row className="justify-content-center">
                            {events.map((event, index) => (
                                <Col key={index} xs={12} lg={6} className="mb-3">
                                    <div className="text-center">
                                        <img
                                            src={event.imgSrc}
                                            alt={`img-${index + 1}`}
                                            className="img-fluid img-cards"
                                        />
                                        <div className="my-2 ft-wt-700 text-primary">{event.title}</div>
                                        <p>{event.description}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default LifeAtAcube;
